// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reviewsBrandDrawer_0aFvI{z-index:100}.reviewsBrandDrawer_0aFvI .v-list:not(.v-select-list){background:var(--cp-white)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reviewsBrandDrawer": "reviewsBrandDrawer_0aFvI"
};
module.exports = ___CSS_LOADER_EXPORT___;
